export const PASSWORD_MIN_LENGTH = 12;
export const NEW_PASSWORD_KEY = 'newPassword';
export const CONFIRM_PASSWORD_KEY = 'confirmPassword';
export const REGEX_UPPERCASE = /(?=.*?[A-Z])/;
export const REGEX_LOWERCASE = /(?=.*?[a-z])/;
export const REGEX_NUMBER = /(?=.*?\d)/;
export const REGEX_SPECIAL_CHARACTER = /(?=.*?[#?!@$%^&*-])/;
